import { createStoreModule } from '../utils';
export default createStoreModule({
  name: 'font',
  modelName: 'fonts',
  crud: true,
  endpoint: {
    delete: '/v2/fonts'
  }
});
